import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { LayoutUtilsService } from '@app/core/_base/crud';
import { MatDialog } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, map } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ModalCreateProducerComponent } from './../modal-create-producer/modal-create-producer.component';
import { ManufacturerService, BrandService } from '@app/api/api';
@Component({
  selector: 'meu-app-producer-management',
  templateUrl: './app-producer-management.component.html',
  styleUrls: ['./app-producer-management.component.scss'],
})
export class AppProducerManagementComponent implements OnInit {
  constructor(
    private layoutUtilsService: LayoutUtilsService,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private ref: ChangeDetectorRef,
    private producerService: ManufacturerService,
    private brandService: BrandService
  ) {}
  displayedColumns: string[] = ['Index', 'Name', 'Code', 'Nation', 'Actions'];
  lstAllProducer: any = [];
  total: any;
  pageSize = 10;
  pageIndex = 1;
  filter: any = '';

  pageSizeOptions: number[] = [5, 10, 20, 100];

  ngOnInit() {
    this.keyUp
      .pipe(
        map((event) => event),
        debounceTime(500)
      )
      .subscribe((value) => {
        this.pageIndex = 1;
        this.filter = 'name|code|nation@=*' + value;
        this.getAllProducer();
      });
    this.getAllProducer();
  }
  public keyUp = new Subject<KeyboardEvent>();
  getAllProducer() {
    this.producerService
      .apiManufacturerGet(this.filter, '', this.pageIndex, this.pageSize)
      .subscribe((res) => {
        if (res.success) {
          this.lstAllProducer = res.data.collection;
          this.total = res.data.total;
          // this.pageIndex=res.data.pageIndex;
          // this.pageSize=res.data.pagesize;
          this.ref.detectChanges();
        } else {
          this.toastr.error(res.message);
        }
      });
  }
  getNameBrandByID(id) {
    this.brandService.apiBrandsIdGet(id).subscribe((res) => {
      if (res.success) {
        return res.data.name;
      } else {
        this.toastr.error(res.message);
      }
    });
  }

  onPageChange(pageNumber: number) {
    if (typeof pageNumber === 'number') {
      this.pageIndex = pageNumber;
      this.getAllProducer();
      window.scrollTo(0, 0);
    }
  }

  onPageSizeChange(newSize: number) {
    this.pageSize = newSize;
    this.pageIndex = 1;
    this.getAllProducer();
  }

  openModalProducer(id) {
    const dialogRef = this.dialog.open(ModalCreateProducerComponent, {
      width: '650px',
      data: { id: id },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined && result.event != undefined) {
        if (result.event) {
          if (result.type == 'create') {
            this.toastr.success('Tạo mới nhà sản xuất thành công');
            this.getAllProducer();
          } else {
            this.toastr.success('Chỉnh sửa nhà sản xuất thành công');
            this.getAllProducer();
          }
        } else {
          this.toastr.error(result.message);
        }
      }
    });
  }
  deleteProducer(ID) {
    const title = 'Xóa nhà sản xuất';
    const description = 'Bạn có chắc chắn muốn xóa nhà sản xuẩt này?';
    const waitDesciption = 'Đang xử lý...';
    const dialogRef = this.layoutUtilsService.deleteElement(title, description, waitDesciption);
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      } else {
        this.producerService.apiManufacturerIdDelete(ID).subscribe((res) => {
          if (res.success) {
            this.toastr.success('Xoá nhà sản xuất thành công');
            this.getAllProducer();
          }
        });
      }
    });
  }
}
